export enum WishListFilterPageSize {
    General = 10,
    FromHomePage = 4
}

export enum WishlistBulkActions {
    ACCEPT = 'Accept',
    REJECT = 'Reject',
    OPEN = 'invited'
}

export const WishlistBottomSheetActions = {
    AcceptSingleProject: 'ACCEPT_SINGLE_PROJECT',
    RejectSingleProject: 'REJECT_SINGLE_PROJECT',
    AcceptAll: 'YES_ACCEPT_ALL',
    RejectAll: 'YES_REJECT_ALL'
};

export enum SortOrder {
    LatestToOldest = 'latestFirst',
    OldestToLatest = 'oldestFirst'
}
